module.exports = __webpack_public_path__ + "img/19.a64d28e2.jpg";